import { Toast } from "jolty";
import NotificationIcons from "@/domains/toasts/constants/notifications-icons.ts";

Toast.Default.topLayer = false;
Toast.Default.limit = 4;
Toast.Default.autohide = 5000;

const getIcon = (eventName) => {
  return NotificationIcons[eventName];
};

Toast.template(({ content, type, autohide }) => {
  const className = `ui-toast ${type ? `ui-toast--${type}` : ""}`;
  const progress = autohide
    ? '<div class="ui-toast-circle-progress" data-ui-autohide-progress></div>'
    : "";
  return `<div class="${className}" data-ui-dismiss><div class="ui-toast-icon"></div><div class="ui-toast-content">${content}</div>${progress}</div>`;
});
Toast.template("game", ({ content, eventName, type }) => {
  const icon = getIcon(eventName);
  const className = `ui-toast ${type ? `ui-toast--${type}` : ""}`;
  const iconElem = icon
    ? `<div class="ui-toast-icon" style="--ui-toast-icon:url(/svg/toast/${icon}.svg)"></div>`
    : "";
  return `<div class="${className}" data-ui-dismiss>${iconElem}<div class="ui-toast-content">${content}</div></div>`;
});

Toast.template("npc", ({ content, type, eventName }) => {
  const icon = getIcon(eventName);
  const className = `ui-toast ui-toast--npc ${type ? `ui-toast--${type}` : ""}`;
  const iconElem = icon
    ? `<div class="ui-toast-icon" style="--ui-toast-icon:url(/svg/toast/${icon}.svg)"></div>`
    : "";
  return `<div class="${className}" data-ui-dismiss>${iconElem}
     <div class="rounded-border"></div>
     <div class="ui-toast-img">
        <div class="rounded-border"></div>
        <img src="/" />
     </div>
     <div class="ui-toast-content">
      <div class="ui-toast-title">${content}</div>
      <div class="ui-toast-description">${content}</div>
     </div>
    </div>`;
});

Toast.template("action", ({ content, type, eventName }) => {
  const icon = getIcon(eventName);
  const className = `ui-toast ${type ? `ui-toast--${type}` : ""}`;
  const iconElem = icon
    ? `<div class="ui-toast-icon" style="--ui-toast-icon:url(/svg/toast/${icon}.svg)"></div>`
    : "";
  return `<div class="${className}" data-ui-dismiss>${iconElem}<div class="ui-toast-content">${content}</div></div>`;
});
Toast.template("debug", ({ content, type }) => {
  const className = `ui-toast ${type ? `ui-toast--${type}` : ""}`;
  return `<div class="${className}" data-ui-dismiss><div class="ui-toast-content"><pre>${content}</pre></div></div>`;
});

const createToast = (options) => {
  if (document.querySelector("#floating-layout")) return null;
  return new Toast(options);
};

// Define functions for different types of toasts
const toast = {
  debug: (content) =>
    createToast({ content, template: "debug", type: "debug", position: "bottom" }),
  success: (content) => createToast({ content, type: "success", position: "bottom-end" }),
  error: (content) => createToast({ content, type: "danger", position: "bottom-end" }),
  info: (content) => createToast({ content, type: "info", position: "bottom-end" }),
  game: {
    success: (content, eventName = null) =>
      createToast({
        content,
        eventName,
        template: "game",
        type: "game-success",
        position: "bottom",
      }),
    error: (content, eventName = null) =>
      createToast({
        content,
        eventName,
        template: "game",
        type: "game-danger",
        position: "bottom",
      }),
    info: (content, eventName = null) =>
      createToast({ content, eventName, template: "game", type: "game-info", position: "bottom" }),
    warning: (content, eventName = null) =>
      createToast({
        content,
        eventName,
        template: "game",
        type: "game-warning",
        position: "bottom",
      }),
  },
  npc: {
    success: (content, eventName = null) =>
      createToast({ content, eventName, template: "npc", type: "npc-success", position: "bottom" }),
    error: (content, eventName = null) =>
      createToast({ content, eventName, template: "npc", type: "npc-danger", position: "bottom" }),
    info: (content, eventName = null) =>
      createToast({ content, eventName, template: "npc", type: "npc-info", position: "bottom" }),
    warning: (content, eventName = null) =>
      createToast({ content, eventName, template: "npc", type: "npc-warning", position: "bottom" }),
  },
  action: {
    success: (content, eventName = null) =>
      createToast({
        content,
        template: "action",
        eventName,
        type: "action-success",
        position: "bottom-start",
      }),
    error: (content, eventName = null) =>
      createToast({
        content,
        template: "action",
        eventName,
        type: "action-danger",
        position: "bottom-start",
      }),
    info: (content, eventName = null) =>
      createToast({
        content,
        template: "action",
        eventName,
        type: "action-info",
        position: "bottom-start",
      }),
    warning: (content, eventName = null) =>
      createToast({
        content,
        template: "action",
        eventName,
        type: "action-warning",
        position: "bottom-start",
      }),
  },
};

export default toast;
